<template>
<div :class="['extrabonus-tooltip', `extrabonus-tooltip__${position}`]">
  <div class="extrabonus-tooltip_body">
    <h4 class="extrabonus-tooltip_title">{{ title }}</h4>
    <div class="extrabonus-tooltip_received extrabonus-tooltip_received__success" v-if="received">{{ $c('Вы уже получили эту награду.') }}</div>
    <div class="extrabonus-tooltip_received" v-else>{{ $c('Это ваша будущая награда.') }}</div>
    <div class="extrabonus-tooltip_content" v-html="content" />
  </div>
</div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
class ExtrabonusTooltip extends Vue {
  @Prop({
    required: true,
    type: String
  }) title
  @Prop({
    required: true,
    type: String
  }) content
  @Prop({
    default: 'right'
  }) position
  @Prop({
    default: false
  }) received
}

export default ExtrabonusTooltip

</script>

<style lang="scss">
.extrabonus-tooltip {
  position: relative;
  &_body {
    min-width: 320px;
    border-radius: 8px;
    background-color: #ffffff;
    padding: 16px;
    box-sizing: border-box;
    position: absolute;
    transform: translateX(-50%);
    bottom: 30px;
    width: 100%;
    @include media_desktop {
      right: 28px;
      top: 50%;
      bottom: auto;
      transform: translateY(-50%);
      min-width: 405px;
    }
    .extrabonus-tooltip__top & {
      right: auto;
      top: auto;
      bottom: 65px;
      left: 50%;
      transform: translateX(-50%);
    }
    &:after {
      content: '';
      width: 14px;
      height: 14px;
      background-color: #ffffff;
      transform: rotate(-45deg);
      position: absolute;
      left: calc(50% - 7px);
      top: calc(100% - 7px);
      @include media_desktop {
        left: auto;
        right: -7px;
        top: calc(50% - 7px);
      }
    }
    .extrabonus-tooltip__top &:after {
      content: '';
      width: 14px;
      height: 14px;
      background-color: #ffffff;
      transform: rotate(-45deg);
      position: absolute;
      right: auto;
      left: calc(50% - 7px);
      top: calc(100% - 7px);
    }
  }
  &_title {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
    margin-bottom: 4px;
  }
  &_content {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #666666;
    p {
      margin-bottom: 8px;
    }
    b {
      color: #000000;
    }
    li {
      margin-bottom: 2px;
    }
  }
  &_received {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #666666;
    margin-bottom: 8px;
    &__success {
      color: #3BB200;
    }
  }
}
</style>
